import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { Moment } from 'moment';
import * as xlsx from 'xlsx';

@Injectable({
  providedIn: 'root',
})
export class FunctionsHelper {
  constructor() { }

  regexPatterns = {
    url: new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?'),
    email: new RegExp(/^\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i),
    date: new RegExp(/^\d{2}\/\d{2}\/\d{4}$/),
  };

  sortRotate = (order: string) => {
    if (order == '') return 'asc';
    if (order == 'asc') return 'desc';
    return '';
  };

  sortCompare = (v1: string | number, v2: string | number) => (v1 < v2 ? -1 : v1 > v2 ? 1 : 0);

  fakeArray(n: number): Array<number> {
    return Array(n);
  }

  validations = {
    optionalUrl: (control: FormControl): { [key: string]: boolean } => {
      if (control.value) {
        if (!this.regexPatterns.url.test(control.value)) {
          return { invalidUrl: true };
        }
      }
      return { invalidUrl: false };
    },
    optionalEmail1: (control: FormControl): { [key: string]: boolean } => {
      if (control.value) {
        if (!this.regexPatterns.email.test(control.value)) {
          return { invalidEmail: true };
        }
      }
      return { invalidEmail: false };
    },
    optionalEmail: (): ValidatorFn => {
      return (control: AbstractControl): ValidationErrors | null => {
        if (!this.regexPatterns.email.test(control.value)) {
          return { invalidEmail: true };
        }
        return null;
      };
    },
  };

  currencyFormatter = (value: number, sign?: string) => {
    const formatted = Math.floor(value)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (sign ? sign : '') + formatted;
  };

  addLeadingZeros(num: number, totalLength: number): string {
    return num.toString().padStart(totalLength, '0');
  }

  ngbDateToMoment(date: NgbDate | null): Moment | null {
    if (date !== undefined && date !== null) {
      const m = moment(date.month + '/' + date.day + '/' + date.year, 'M/D/YYYY');
      return m;
    }
    return null;
  }

  momentToNgbDate(momentDate: moment.Moment): NgbDate {
    return new NgbDate(momentDate.year(), momentDate.month() + 1, momentDate.date());
  }

  monthNames: string[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  readCSVFile(file: File) {
    return new Promise<any>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const data = reader.result as string;
        const workbook = xlsx.read(data, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData: Array<any> = xlsx.utils.sheet_to_json(sheet, { header: 1, blankrows: false });
        if (!jsonData || jsonData.length < 2) {
          reject('notEnoughData');
        }

        resolve(jsonData);
      };
      reader.readAsBinaryString(file);
    });
  }

  removeFileExtension = (fileName: string): string => {
    const lastDotIndex = fileName.lastIndexOf('.');
    if (lastDotIndex === -1) return fileName;
    return fileName.substring(0, lastDotIndex);
  };

}
